<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VmGSjd/tc-custom/9781601638632.jpg?1708777867139" alt="This image is the cover for the book Executive Guide to E-mail Correspondence"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Executive Guide to E-mail Correspondence
      </h1>
      <p class="bookDescription body article font2">
        <b>Make your messages shorter, simpler, and more effective with this guide to writing e-mails that get read—and get results.</b><br/><br/>As we correspond with everyone from international partners to remote workers, writing skills are more important than ever to business and career success. They can make the difference between climbing the corporate ladder and getting stuck on a low rung. An e-mail that’s clear, concise, and targeted will get more than just a response. It will get results—including your boss’s attention.<br/><br/>No matter what sector a company is in, excellent written communication skills are in demand—because too-long, wordy, or unclear emails bog down a business. This guide provides insight, guidelines, and a wide variety of templates to help you get it right and rapidly transform basic writing skills into global communications expertise. In a lively, here’s-how style, it:demonstrates the hallmarks of effective business e-mailsfeatures ready-to-use organizational planspresents quick and easy editing techniquesfurnishes before-and-after editing modelsfocuses on the do’s and don’ts of proficient e-mailssupplies practical writing tips and tricks, and more
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dawn-Michelle Baude
      </h2>
      
      <p class="authorDescription body article">Dawn-Michelle Baude is an international corporate speaker specializing in global communications. She has lectured throughout Europe and Asia to businesses and alumni groups alike. An accomplished professional, she has written copy for Gucci perfumes and feature articles for Reader's Digest and Vogue. She also co-authored a self-help best-seller, Savoir Dire Non (Flammarion 2006). In 2000, she began working as a writing consultant for IBM Corp. She holds an M.A., an M.F.A., a D.E.A. and a Ph.D. in English. A 2005-06 Senior Fulbright Scholar in Creative Writing, she teaches at the American University of Paris.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Career Press, Incorporated
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4cd75164